import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { useSelector } from 'react-redux';
import Biovisuals_Logo from '../../assets/images/Logo/Bharat-Darshan-Logo.png'
import { NextBtnSvg, PrevBtnSvg, DoublePrevBtnSvg, DoubleNextBtnSvg } from '../../assets/svg';

const PaginationDatatable = ({ data = [], columns, url, handlePageChange, currentPage, handleNextPageChange, handlePrevPageChange, paginationData }) => {
    const { isLoading } = useSelector(state => state?.dashboard)
    console.log("totalDocument", paginationData?.total)
    console.log('currentPage PD', currentPage)

    //* DataTable Styles
    const DataTableCustomStyles = {
        cells: {
            style: {
                textAlign: "center",
                color: "rgba(0, 0, 0, 0.6)", whiteSpace: "nowrap",
                fontFamily: 'Philosopher',
                width: "150px"
            },
        },
        rows: {
            style: {
                minHeight: '65px',
                backgroundColor: "#fff",
                fontFamily: 'Philosopher'
            },
        },
        headRow: {
            style: {
                whiteSpace: 'nowrap',
                fontSize: "14px",
                fontWeight: "600", color: "#667284",
                backgroundColor: '#E2E8F0',
                fontFamily: 'Philosopher'
            }
        }
    };

    return (
        <div style={{ padding: '25px' }}>
            {isLoading ?
                <div style={{ color: "black", textAlign: "center", minHeight: "400px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontFamily: 'Philosopher', animation: 'rotation 2s infinite linear' }}>
                    <img src={Biovisuals_Logo} style={{ height: "100px", height: "100px" }} alt="" />
                </div>
                :
                <>
                {/* onChange={()=>navigate(`transaction/${transactionHistory?._id}`)} */}
                    <DataTable className='react-data-table'
                        columns={columns}
                        data={data}
                        customStyles={DataTableCustomStyles}
                        paginationTotalRows={paginationData?.total}
                        paginationComponentOptions={false}
                        fixedHeader
                        paginationRowsPerPageOptions={[10]}
                    />

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: '30px', padding: "10px 20px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div style={{ fontFamily: 'Philosopher', fontSize: "14px", color: '#666674' }}>{(paginationData?.currentPage * 5) - 5 + (paginationData?.total == 0 ? 0 : 1)}-{paginationData?.hasNextPage ? paginationData?.limit * paginationData?.currentPage : paginationData?.total}</div>
                            <div style={{ fontFamily: 'Philosopher', fontSize: "14px", color: '#666674' }}>of</div>
                            <div style={{ fontFamily: 'Philosopher', fontSize: "14px", color: '#666674' }}>{paginationData?.total}</div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                            <button style={{ background: "none", border: "none" }} disabled={currentPage == 1} onClick={() => handlePageChange(1)}><DoublePrevBtnSvg /></button>
                            <button style={{ background: "none", border: "none" }} disabled={!paginationData?.hasPrevPage} onClick={() => handlePrevPageChange(1)}><PrevBtnSvg /></button>
                            <button style={{ background: "none", border: "none" }} disabled={!paginationData?.hasNextPage} onClick={() => handleNextPageChange(1)}><NextBtnSvg /></button>
                            <button style={{ background: "none", border: "none" }} disabled={paginationData?.totalPages == 0 ? true : paginationData?.totalPages == currentPage} onClick={() => handlePageChange(paginationData?.totalPages)}><DoubleNextBtnSvg /></button>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default PaginationDatatable;